import { ContextService } from './context.service';
import { ContextWriterService } from './context-writer.service';

export const Services = [
	ContextService,
	ContextWriterService,
];
